export class AssessmentActionPlanItem {
  description: string;
  dateAdded: string;
  dueDate: string;
  improvementPlanStatusID: number;
  itemNumber: number;
  requestKey: string;

  fieldsDisabled: boolean = false;
  actionPlanItemTitleDisabled: boolean = false;
  dueDateDisabled: boolean = false;
  improvementPlanStatusDisabled: boolean = false;

  constructor() {
    this.description = "";
    this.dateAdded = "";
    this.dueDate = "";
    this.improvementPlanStatusID = 0;
    this.itemNumber = 0;
    this.requestKey = "";

    this.fieldsDisabled = false;
    this.actionPlanItemTitleDisabled = false;
    this.dueDateDisabled = false;
    this.improvementPlanStatusDisabled = false;
  }

}
